import styled from '@emotion/styled';
import { css } from 'emotion';

import { SIZES } from '@ezugi/constants/src/sizes';

import { SB_GAME_BOARD_HEIGHT } from './constants';

const LAST_ROUNDS_HEIGHT = 30;

export const Section = styled.section`
  height: 100%;
  top: 0;
  display: inline-block;
  vertical-align: top;
  position: relative;
  transition: flex 0.27s linear, height 0.27s linear, transform 0.27s linear;
  transform-origin: bottom center;
  flex: 1;

  flex-flow: column nowrap;

  &[data-name='left-section'] {
    transform-origin: bottom left;
  }

  &[data-name='right-section'] {
    transform-origin: bottom right;
  }
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: ${SB_GAME_BOARD_HEIGHT}%;
  bottom: 0;
  left: 0;
  pointer-events: all;
  user-select: none;
  background: transparent;
  flex-flow: row nowrap;
  transform: translateY(0);
  transition: transform 0.13s linear;

  #bet-icon {
    pointer-events: all;
  }

  [id^='bet-'] {
    &:active {
      .highlight {
        fill-opacity: 0.85;
      }
    }

    text {
      text-transform: uppercase;
    }
  }
`;

export const desktopContainer = css`
  display: flex;
  align-items: flex-end;

  [id^='bet-'] {
    &:hover {
      cursor: pointer;
      .highlight {
        fill-opacity: 0.85;
      }
    }
  }

  [data-name='left-section'],
  [data-name='right-section'] {
    max-width: ${SB_GAME_BOARD_HEIGHT}%;
  }
`;

export const inactiveGrid = css`
  pointer-events: none;
`;

export const centerSectionClassName = css`
  perspective: 900px;
  align-items: center;
  flex-flow: column nowrap;
  flex: 1.5;
  transform-origin: center bottom;

  > [data-e2e='progress-bar'] {
    height: 30px;
    z-index: -1;
  }
`;

export const rightSectionClassName = css`
  padding-top: 52px;
`;

export const gridUpClassName = css`
  transform: scale(1.41);
`;

export const downscaledSideSections = css`
  transform: scale(0.7);
`;

export const mobileCenterSectionClassName = css`
  display: flex;
  justify-content: center;
  overflow: visible;

  @media all and (orientation: portrait) {
    display: flex;
    width: 100%;
    perspective: 3000px;
  }
`;

export const desktopBetGridClassName = css`
  padding: 2px;
  height: calc(100% - ${SIZES.HEADER_DESKTOP_HEIGHT}px);
  width: 100%;
`;

export const progressBarClassName = css`
  width: 100%;
  border-radius: 0;
`;

export const mobileContainerClassName = css`
  flex-flow: column nowrap;
  height: 100% !important;
  padding-bottom: ${LAST_ROUNDS_HEIGHT}px;
  transition: none;

  section {
    background: none;
  }

  @media all and (orientation: landscape) {
    flex-flow: column-reverse nowrap;
    width: 66%;
    margin-left: auto;
    transition: all 0.6s ease-in-out;
    padding-right: ${SIZES.MOBILE_LANDSCAPE_BET_TOOLBAR_SIZE}px;
    display: block;
  }
`;

export const mobileBetsClosedClassName = css`
  padding: 4px 0px 34px 0px;
  @media all and (orientation: portrait) {
    svg {
      width: 100%;
      height: auto;
      margin: 0 auto;
    }
  }

  @media all and (orientation: landscape) {
    transform: scale(0.6);
    transform-origin: center right;
    overflow: visible;
    margin-right: 4px;
  }
`;

export const mobileLastRounds = css`
  left: 0;
  width: 100%;
  z-index: 1;
  justify-content: center;
  align-items: center;
  padding: 4px;

  > div {
    background-color: rgba(0, 0, 0, 0.5);
  }

  @media all and (orientation: portrait) {
    display: flex;
    transform: translateY(-100%);
    position: absolute;
    top: 0;
  }

  @media all and (orientation: landscape) {
    display: flex;
    flex-flow: column;
    position: absolute;
    right: 10px;
    width: 30px;
    left: initial;
    top: 0;
    padding: 0;
  }
`;

export const lastRoundsNMB = css`
  @media all and (orientation: landscape) {
    top: -${SIZES.APPBAR_PORTRAIT_HEIGHT}px;
  }
`;

export const sicboStudioColor = css`
  background-color: #52171b;

  [data-e2e='game-video'] {
    color: #52171b;
  }

  #root,
  #app,
  [data-e2e='bet-toolbar'],
  [data-e2e='bet-toolbar']::before {
    background: transparent;
  }
`;

export const expandClassName = css`
  width: 68% !important;
  margin-right: 3px;
`;
